import BaseFormPresenter from "../../base/BaseFormPresenter";
import { deleteObjectUseCase } from "../../usecases/object";
import {
  isStrongPassword,
  PASSWORD_TITLE,
} from "../../components/InputFactory/passwordPolicy";

class AccountPresenter extends BaseFormPresenter {
  constructor(view, getObjectUseCase, upsertUseCase, signInUseCase) {
    super(view, getObjectUseCase, upsertUseCase);
    this.signInUseCase = signInUseCase;
    this.password = {};
  }

  onChangePassword(value, field) {
    this.password[field] = value;
  }

  async onChangePicture(value) {
    this.change["picture"] = value;
    await this.submit();
    this.view.reload();
  }

  async onSubmitPassword() {
    const { oldPassword, newPassword, confirmNewPassword } = this.password;
    if (!isStrongPassword(newPassword)) {
      this.view.showError(PASSWORD_TITLE);
      return;
    }
    if (newPassword !== confirmNewPassword) {
      this.view.showError("Password must be the same");
      return;
    }
    try {
      const user = this.object;
      await this.signInUseCase.execute(
        {
          username: user.username,
          password: oldPassword,
        },
        { token: false }
      );
      console.log("USER: ", user);
      user.employee = { id: user.employee.id };
      this.change["password"] = this.password["newPassword"];
      this.change["isReset"] = true;
      await this.submit();
    } catch (error) {
      if (error.code === 404) {
        this.view.showError("Invalid old password");
        return;
      }
      console.error("ERROR: ", error);
      this.view.showError(error);
    }
  }
}

export default AccountPresenter;
